// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LeftCircleTwoToneSvg from "@ant-design/icons-svg/es/asn/LeftCircleTwoTone";
import AntdIcon from '../components/AntdIcon';

var LeftCircleTwoTone = function LeftCircleTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: LeftCircleTwoToneSvg
  }));
};

LeftCircleTwoTone.displayName = 'LeftCircleTwoTone';
export default React.forwardRef(LeftCircleTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/LeftCircleTwoTone.js
// module id = 1399
// module chunks = 0